import { getCountFromServer, onSnapshot, orderBy, limit, query, type Query, type DocumentData } from 'firebase/firestore';

export interface Pastille { nombre: number; dernierAt: Date | null; motif: 'arrivee' | 'synchronisation' }
/** Le signal borne reveille un compte serveur. Le premier instantane et le retour du cache ne sont pas des arrivees. */
export function observerPastille(signal: Query<DocumentData>, compter: () => Promise<number>, recevoir: (p: Pastille) => void, erreur?: (e: unknown) => void, depuis = Number.POSITIVE_INFINITY): () => void {
  let vivant = true, tour = 0, precedent = 0, serveur = false;
  let dernierAt: Date | null = null;
  const recompter = (motif: Pastille['motif'] = 'synchronisation') => {
    const n = ++tour;
    void compter().then(nombre => { if (vivant && n === tour) recevoir({ nombre, dernierAt, motif }); }).catch(e => erreur?.(e));
  };
  const arret = onSnapshot(query(signal, orderBy('createdAt', 'desc'), limit(1)), { includeMetadataChanges: true }, snap => {
    const at = snap.docs[0]?.data()['createdAt'];
    dernierAt = at && typeof at.toDate === 'function' ? at.toDate() : null;
    const instant = at?.toMillis?.() ?? dernierAt?.getTime() ?? 0;
    const estServeur = !snap.metadata.fromCache && !snap.metadata.hasPendingWrites;
    const motif = motifPastille(estServeur, serveur, instant, precedent, depuis);
    if (estServeur) precedent = instant;
    serveur = estServeur;
    if (estServeur) recompter(motif);
  }, erreur);
  const retour = () => { if (typeof document === 'undefined' || !document.hidden) { serveur = false; depuis = Date.now(); recompter(); } };
  globalThis.addEventListener?.('online', retour);
  globalThis.addEventListener?.('focus', retour);
  return () => { vivant = false; arret(); globalThis.removeEventListener?.('online', retour); globalThis.removeEventListener?.('focus', retour); };
}
export async function compteServeur(q: Query<DocumentData>): Promise<number> { return (await getCountFromServer(q)).data().count; }

/** Le retour au premier plan ne rejoue pas les arrivees passees, mais autorise les futures. */
export function motifPastille(estServeur: boolean, serveurPrecedent: boolean, instant: number, precedent: number, depuis: number): Pastille['motif'] {
  return estServeur && instant > precedent && (serveurPrecedent || instant > depuis) ? 'arrivee' : 'synchronisation';
}
